import { render, staticRenderFns } from "./HistorialEquipoWebApp.vue?vue&type=template&id=36350a54&"
import script from "./HistorialEquipoWebApp.vue?vue&type=script&lang=js&"
export * from "./HistorialEquipoWebApp.vue?vue&type=script&lang=js&"
import style0 from "./HistorialEquipoWebApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports